import styled from 'styled-components';

export const ModalCarouselWrapper = styled.div`
    .modal-collapse-scrollable .ant-collapse {
        background-color: #f9f9f9;
        border-radius: 2px;
        border: none;
    }

    .modal-collapse-scrollable .ant-collapse-content {
        background-color: #fff;
        padding: 12px 20px;
        border-top: 1px solid #eee;
    }

    /* Collapse active header styles */
    .modal-collapse-scrollable .ant-collapse-item-active .ant-collapse-header {
        background-color: #e6f7ff;
    }
    
    .modal-collapse-scrollable .ant-collapse-item-active .ant-collapse-header .text-gray-800,
    .modal-collapse-scrollable .ant-collapse-item-active .ant-collapse-header .fw-bold,
    .modal-collapse-scrollable .ant-collapse-item-active .ant-collapse-header .text-hover-danger,
    .modal-collapse-scrollable .ant-collapse-item-active .ant-collapse-header .gotham_black,
    .modal-collapse-scrollable .ant-collapse-item-active .ant-collapse-header .fs-6 {
        color: #1677ff !important;
    }
`;